import { render, staticRenderFns } from "./AttachmentModal.vue?vue&type=template&id=0f435968"
import script from "./AttachmentModal.vue?vue&type=script&lang=js"
export * from "./AttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports